import { UserService } from "@Services/User.service"
import axios from "axios"
import { useEffect, useState } from "react"

export const useGenerateLiveKitToken = () => {
    const [fetchingToken, setFetchingToken] = useState(false)
    const [userLiveKitToken, setUserLiveKitToken] = useState("")

    const handleFetchLiveKitToken = async ({ roomName, participantName }) => {
        setFetchingToken(true)
        console.log({ roomName: roomName })
        try {
            const response = await axios.post(
                "https://openvidu.api.ivehte.fr/token",
                {
                    roomName,
                    participantName
                },
                {
                    headers: {
                        "Content-Type": "application/json" // Setting the Content-Type header
                    }
                }
            )

            if (response?.data?.token) {
                setUserLiveKitToken(response.data.token)
            }
            setFetchingToken(false)
        } catch (error) {
            console.error("Error fetching Livekit token:", error)
            setFetchingToken(false)
        }
    }

    return {
        handleFetchLiveKitToken,
        fetchingToken,
        userLiveKitToken
    }
}
